const upgradeGalleryMedia = (gallery, includeHero = true) => {
  gallery.querySelectorAll('img[data_sr_deferred_srcset]').forEach((image) => {
    if (!includeHero && image.fetchPriority === 'high') return;

    const deferredSrcset = image.getAttribute('data_sr_deferred_srcset');
    const deferredSrc = image.getAttribute('data_sr_deferred_src');

    if (deferredSrcset) image.srcset = deferredSrcset;
    if (deferredSrc) image.src = deferredSrc;

    image.removeAttribute('data_sr_deferred_srcset');
    image.removeAttribute('data_sr_deferred_src');
  });
};

document.querySelectorAll('media-gallery').forEach((gallery) => {
  const upgrade = () => upgradeGalleryMedia(gallery, true);

  gallery.addEventListener('pointerdown', upgrade, { once: true, passive: true });
  gallery.addEventListener('focusin', upgrade, { once: true });
  gallery.addEventListener('keydown', upgrade, { once: true });

  window.addEventListener(
    'load',
    () => {
      window.setTimeout(() => upgradeGalleryMedia(gallery, false), 1200);
    },
    { once: true }
  );
});
